export default __webpack_public_path__ + "static/media/howItWorksOne.a6d8ddd3.png";